import { useEffect, useRef } from "react";
import QRCodeStyling from "qr-code-styling";

export default function QRContainer({ alias, size = 300, exportContainer, onReady }) {
  const qrRef = useRef(null);
  const qrCode = useRef(null);

  // inicializácia qrCode len raz pre každý komponent
  useEffect(() => {
    qrCode.current = new QRCodeStyling({
      width: size,
      height: size,
      data: `http://kontaktuj.sk/${alias}`,
      image: "qr/logo.png",
      dotsOptions: {
        color: "#000000",
        type: "rounded",
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 0,
      },
    });

    if (qrRef.current) {
      qrCode.current.append(qrRef.current);
    }
  }, []);

  // update pri zmene aliasu alebo size
  useEffect(() => {
    if (!qrCode.current) return;

    qrCode.current.update({
      data: `http://kontaktuj.sk/${alias}`,
      width: size,
      height: size,
    });

    // prerender
    if (qrRef.current) {
      qrRef.current.innerHTML = "";
      qrCode.current.append(qrRef.current);
    }

    // úprava rozmerov + textov
    const qrLogoDiv = qrRef.current?.closest("#qrlogo");
    if (qrLogoDiv) {
      qrLogoDiv.style.width = `${(size * 360) / 300}px`;
      qrLogoDiv.style.border = `solid ${4 * size / 300}px black`;
      qrLogoDiv.style.borderRadius = `${10 * size / 300}px`;
      const topText = qrLogoDiv.querySelector("#qrtoptext");
      const bottomText = qrLogoDiv.querySelector("#qrbottomtext");
      const qrRefContent = qrLogoDiv.querySelector("#qrRefContent");
      if (topText) topText.style.fontSize = `${(size / 300) * 2.0}rem`;
      if (bottomText) bottomText.style.fontSize = `${(size / 300) * 1.4}rem`;
      if (qrRefContent) qrRefContent.style.padding = `${(size > 250 ? '5' : '0')}%`;
    }

    if (onReady && size !== 100) {
      //TODO: FIX THIS DIRTY HACK => rendering Page => QRContainer => timeout 1s (waiting for qr render) => onReady in QRContainer => download
      setTimeout(() => {
        onReady();
      }, 1000)
    }
  }, [alias, size]);

  const setStyle = () => {
    return exportContainer ? {
      position: 'absolute',
      left: -99999,
      top: -99999,
    } : {};
  }

  return (
    <div id={exportContainer ? 'exportContainer' : 'maincontainer'} style={setStyle()}>
      <div style={{ display: "flex", flexDirection: "column", marginTop: "0px" }}>
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
          <div
            id="qrlogo"
            style={{ width: 360, border: "solid 4px black", borderRadius: 10 }}
          >
            <div style={{ background: "black", color: "white" }}>
              <p id="qrtoptext" style={{ margin: 0, fontSize: "2.0rem" }}>
                KONTAKTUJ MA
              </p>
            </div>
            <div id="qrRefContent" style={{ border: "solid black", background: "white", padding: '1%' }} ref={qrRef} />
            <div style={{ background: "black", color: "white" }}>
              <p id="qrbottomtext" style={{ margin: 0, fontSize: "1.4rem" }}>
                KONTAKTUJ.SK/{alias}
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
